export default function observeStore(store, select, onChange) {
    const { getState, dispatch } = store;
    let currentState;

    function handleChange() {
        const nextState = select(getState());
        if (nextState !== currentState) {
            onChange(currentState, nextState, dispatch);
            currentState = nextState;
        }
    }

    const unsubscribe = store.subscribe(handleChange);
    handleChange();
    return unsubscribe;
};



// WEBPACK FOOTER //
// ./app/lib/observe/observeStore.js